<div class="layout horizontal center middle"
     (mouseover)="hover=true" 
     (mouseleave)="hover=false"
     [ngStyle]="{
         'width': settings.width,
         'height': settings.height,
         'margin': settings.margin,
         'color': selected ? settings.selectedSettings.fontColor 
                             : hover ? settings.hoverSettings.fontColor 
                             : settings.fontColor,
         'border': settings.border,
         'border-radius': settings.borderRadius,
         'background-color': selected ? settings.selectedSettings.bgColor 
                             : hover ? settings.hoverSettings.bgColor 
                             : settings.bgColor}"
     [matTooltip]="tooltip">
    <mat-icon [svgIcon]="id" 
              [ngStyle]="{
                  'width': settings.size,
                  'height': settings.size}"
              >
    </mat-icon>
    <!--style="height:48px !important; width:48px !important; font-size:48px !important;"-->
</div>

